import React, {Component, PropTypes} from 'react'
import Slider from 'rc-slider'

export default class AgeRange extends Component {

  static propTypes = {
    setRange: PropTypes.func.isRequired,
    ageRange: PropTypes.shape({
      current: PropTypes.array.isRequired,
      limit: PropTypes.array.isRequired
    }).isRequired
  }

  render() {
    const {ageRange, setRange} = this.props

    return <div className='age-selector'>
      <span className='age'>Amžius</span>
      <Slider range
              min={ageRange.limit[0]}
              max={ageRange.limit[1]}
              defaultValue={[ageRange.current[0], ageRange.current[1]]}
              onChange={setRange} />
      <span className="selected-age">{ageRange.current[0]} - {ageRange.current[1]} m.</span>
    </div>
  }
}

